import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createTrainingProgram,
    updateTrainingProgram,
    clearMessages as clearProgramMessages
} from '../../../redux/slices/admin/trainingSlice';

const ProgramModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        program_name: '',
        days: '',
        weeks: '',
        gender: 'All',
        user_type: 'Both',
        status: '',
        description: '',
        image:null
    });

    const successMessage = useSelector((state) => state.trainingPrograms?.successMessage);
    const errorMessage = useSelector((state) => state.trainingPrograms?.error);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                program_name: initialData.program_name || '',
                days: initialData.days || '',
                weeks: initialData.weeks || '',
                gender: initialData.gender || 'All',
                user_type: initialData.user_type || 'Both',
                status: initialData.status || '0',
                description: initialData.description || '',
                image:null
            });
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value, files } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'image' ? files[0] : value,
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
       /** const payload = {
            id: isEditMode ? initialData.id : undefined, // Include id if editing
            program_name: formData.program_name,
            days: formData.days,
            weeks: formData.weeks,
            gender: formData.gender,
            status: formData.status,
            description: formData.description
        };**/

        const form = new FormData();
        form.append('program_name', formData.program_name);
        form.append('days', formData.days);
        form.append('weeks', formData.weeks);
        form.append('gender', formData.gender);
        form.append('user_type', formData.user_type);
        form.append('status', formData.status);
        form.append('description', formData.description);
        form.append('image', formData.image);

        if (isEditMode) {
            form.append('id', isEditMode ? initialData.id : undefined); // Include id if editing
        }

        if (isEditMode) {
            await dispatch(updateTrainingProgram({programData:form, id:initialData.id })); // Send payload directly for update
        } else {
            await dispatch(createTrainingProgram(form)); // Send payload directly for creation
        }
    };

    const handleClose = () => {
        dispatch(clearProgramMessages());
        // Clear the form data only when the modal is closed
        setFormData({
            program_name: '',
            days: '',
            weeks: '',
            gender: 'All',
            user_type: 'Both',
            status: '',
            description: '',
            image:null
        });
        closeModal();
    };

 const fileInputRef = useRef(null);

  useEffect(() => {
    if (formData.meal_picture === null && fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, [formData.meal_picture]);

    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="modalProgramLabel">{isEditMode ? 'Edit Program' : 'Create New Program'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Program Name"
                                        className="form-control form-control-lg"
                                        name="program_name"
                                        value={formData.program_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Days/Week"
                                        className="form-control form-control-lg"
                                        name="days"
                                        value={formData.days}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        placeholder="Weeks"
                                        className="form-control form-control-lg"
                                        name="weeks"
                                        value={formData.weeks}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-control form-control-lg"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleFormChange}
                                        required
                                    >
                                        <option value="All">All</option>
                                        <option value="M">Male</option>
                                        <option value="F">Female</option>
                                    </select>
                                </div> 

                                <div className="col-md-6">
                                    <select
                                        className="form-control form-control-lg"
                                        name="user_type"
                                        value={formData.user_type}
                                        onChange={handleFormChange}
                                        required
                                    >
                                        <option value="All">Select User Type</option>
                                        <option value="Both">Both</option>
                                        <option value="1-1 Premium">1-1 Premium</option>
                                        <option value="Academy Client">Academy Client</option>
                                    </select>
                                </div> 

                                <div className="col-md-6">
                                    <select
                                        className="form-control form-control-lg"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleFormChange}
                                        required
                                    >
                                        <option value="">Select Status</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <div className="position-relative">
                                    <input
                                        type="file"
                                        name="image"
                                        className="form-control form-control-lg form-control-choose"
                                        ref={fileInputRef}
                                        onChange={handleFormChange}
                                        style={formData.image === null ? { borderColor: 'red' } : {}}
                                      />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <textarea
                                        type="text"
                                        placeholder="Description"
                                        className="form-control form-control-lg"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleFormChange}
                                        
                                    />
                                </div>


                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                    {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ProgramModal;